module.exports = __webpack_public_path__ + "media/images/webpage/pages/about/trust-8f147530196b27fc51d94de2614e8729.webp";